import { Image } from '@starsoft/common/components';
import { WalletService } from '@starsoft/common/services';
import useTranslation from 'next-translate/useTranslation';
import { BetResultProps } from './props';
import BetResultSkeleton from './Skeleton';
import styles from './styles.module.scss';
export default function BetResult({ bets, isPending }: BetResultProps) {
  const { t } = useTranslation('game-report');

  const payout = bets?.[0]?.payout;

  const won = payout?.toNumber() > 0 ? true : false;

  function getPayout(): string {
    if (!payout) return '0';
    return WalletService.maskCurrency({
      amount: payout,
      coin: bets?.[0]?.coin,
    });
  }

  if (isPending) {
    return <BetResultSkeleton />;
  }

  return (
    <div className={styles.container}>
      <span className={styles.container__title}>{t('profit_label')}</span>

      <div className={styles.container__result}>
        <Image
          className={styles.container__result__coin}
          alt="coin-image"
          src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/coins/rounded/${bets?.[0]?.coin?.image ?? 'usdt.svg'}`}
          secondarySkeleton
        />
        <span
          className={`${styles.container__result__value} ${
            won ? styles['container__result__value--won'] : ''
          }`}
        >
          {getPayout()}
        </span>
      </div>
    </div>
  );
}
